module.exports = __webpack_public_path__ + "static/media/020.a42761e9.jpg";